// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Login.module.css */

.container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--background);
  padding: 16px;
  font-family: 'Inter', sans-serif;
}

.form {
  width: 100%;
  max-width: 350px;
  background: var(--background);
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
  padding: 32px 18px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.formHeader {
  text-align: center;
  margin-bottom: 10px;
}

.title {
  margin: 0;
  color: var(--foreground);
  font-weight: 700;
  font-size: 1.5rem;
}

.subtitle {
  font-size: 0.9375rem; /* 15px -> 0.9375rem for consistency */
  color: var(--muted-foreground);
  margin-top: 4px;
}

.input {
  padding: 12px;
  border-radius: 6px;
  border: 1px solid var(--border);
  font-size: 16px;
  outline: none;
  background: var(--muted);
  width: 100%;
  box-sizing: border-box;
}

.submitButton {
  padding: 12px;
  border-radius: 8px;
  background: linear-gradient(45deg, var(--primary), var(--secondary));
  color: var(--background);
  font-weight: 600;
  font-size: 16px;
  border: none;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  width: 100%;
  text-decoration: none;
}

.submitButton:disabled {
  cursor: not-allowed;
}

.error {
  color: var(--danger);
  margin-bottom: 12px;
}

.terms {
  font-size: 13px;
  color: var(--muted-foreground);
  text-align: center;
  margin-top: 8px;
}

.terms a {
  color: var(--primary);
}

.register {
  text-align: center;
  margin-top: 14px;
  font-size: 14px;
  color: var(--muted-foreground);
}

.register a {
  color: var(--primary);
}

@media (max-width: 480px) {
  .form {
    padding: 18px 8px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  }
  .title {
    font-size: 1.1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Login.css"],"names":[],"mappings":"AAAA,qBAAqB;;AAErB;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB,EAAE,sCAAsC;EAC5D,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,wBAAwB;EACxB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,oEAAoE;EACpE,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,uCAAuC;EACvC,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,sCAAsC;EACxC;EACA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* Login.module.css */\n\n.container {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--background);\n  padding: 16px;\n  font-family: 'Inter', sans-serif;\n}\n\n.form {\n  width: 100%;\n  max-width: 350px;\n  background: var(--background);\n  border-radius: 12px;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);\n  padding: 32px 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.formHeader {\n  text-align: center;\n  margin-bottom: 10px;\n}\n\n.title {\n  margin: 0;\n  color: var(--foreground);\n  font-weight: 700;\n  font-size: 1.5rem;\n}\n\n.subtitle {\n  font-size: 0.9375rem; /* 15px -> 0.9375rem for consistency */\n  color: var(--muted-foreground);\n  margin-top: 4px;\n}\n\n.input {\n  padding: 12px;\n  border-radius: 6px;\n  border: 1px solid var(--border);\n  font-size: 16px;\n  outline: none;\n  background: var(--muted);\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.submitButton {\n  padding: 12px;\n  border-radius: 8px;\n  background: linear-gradient(45deg, var(--primary), var(--secondary));\n  color: var(--background);\n  font-weight: 600;\n  font-size: 16px;\n  border: none;\n  cursor: pointer;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.08);\n  width: 100%;\n  text-decoration: none;\n}\n\n.submitButton:disabled {\n  cursor: not-allowed;\n}\n\n.error {\n  color: var(--danger);\n  margin-bottom: 12px;\n}\n\n.terms {\n  font-size: 13px;\n  color: var(--muted-foreground);\n  text-align: center;\n  margin-top: 8px;\n}\n\n.terms a {\n  color: var(--primary);\n}\n\n.register {\n  text-align: center;\n  margin-top: 14px;\n  font-size: 14px;\n  color: var(--muted-foreground);\n}\n\n.register a {\n  color: var(--primary);\n}\n\n@media (max-width: 480px) {\n  .form {\n    padding: 18px 8px;\n    border-radius: 8px;\n    box-shadow: 0 2px 8px rgba(0,0,0,0.08);\n  }\n  .title {\n    font-size: 1.1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
